class exports.DeleteWeightSetDialog extends DialogHandler

    init: () ->
        @layoutUrl = 'backend/portal/weightings/load-delete-dialog'
        @saveUrl = 'backend/portal/weightings/delete-weight-set'
        @classes = 'small_dialog'

        @refreshNavHandler = false
        @successAction = @updateTaffy

        @createDialog()

    afterLoadLayout: () ->
        @dialog.find('.save-btn').bind 'click', () =>
            @save('Deleting weight set...')

        @openDialog()


    updateTaffy: (response) ->
        ws = response.data

        # make zones available for selecting
        zoneSel = $(@parent.layoutSelector).find('select[name="sel_assoc"]')

        szIDs = []
        zoneSel.children().each () ->
            szIDs.push $(this).attr 'value'

        zoneSel.val(szIDs)
        @parent.deassocZones false

        # update taffy
        @parent.taffyObjects.ws( id: ws.id ).remove()

        @parent.renderWeightSetSelect()
        @parent.renderZoneSelects()
